import { ActionHandler } from '../actionHandler';

const COLORS = {
  blue: 'bg-blue-500 hover:bg-blue-500/90 text-white',
  amber: 'bg-amber-500 hover:bg-amber-500/90 text-white',
  green: 'bg-green-500 hover:bg-green-500/90 text-white',
  red: 'bg-red-500 hover:bg-red-500/90 text-white',
  yellow: 'bg-yellow-500 hover:bg-yellow-500/90 text-white',
  purple: 'bg-purple-500 hover:bg-purple-500/90 text-white',
  pink: 'bg-pink-500 hover:bg-pink-500/90 text-white',
  slate: 'border-slate-200 bg-slate-50 !text-slate-400'
};

const sharedClasses =
  'w-full items-center flex font-hmedium text-[0.8rem] cursor-pointer justify-center capitalize-first border border-solid !border-0';

export function State({ height = '', label, color = 'slate', ...rest }) {
  return (
    <ActionHandler {...rest} data={{ state: label }}>
      <div className={`${height} ${sharedClasses} ${COLORS[color]}`}>{label}</div>
    </ActionHandler>
  );
}
